export const token = localStorage.getItem(`AuthToken`)

export const FINANCE_REQUEST_STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  PENDING_BANK_APPROVAL: 'PENDING_BANK_APPROVAL',
  DECLINED: 'DECLINED',
}

export const SYSTEM_ROLES = {
  HRM: 'HRM',
  CTO: 'CTO',
  CEO: 'CEO',
  OPERATIONS_MANAGER: 'OPERATIONS_MANAGER',
  HR_EXECUTIVE: 'HR_EXECUTIVE',
  TECHNICAL_RECRUITER: 'TECHNICAL_RECRUITER',
  INTERNEE: 'INTERNEE',
  ADMIN_OFFICER: 'ADMIN_OFFICER',
  STAFF: 'STAFF',
  SALES_EXECUTIVE: 'SALES_EXECUTIVE',
}

export const BANK_TYPES = {
  ALL: 'ALL',
  FBL: 'FBL',
  IBFT: 'IBFT',
}
